// Full-screen search overlay. Triggered from the sidebar Search box (or ⌘K).
// Calls chat_search_messages RPC, ranks by ts_rank, and renders results
// grouped by channel. Clicking a result jumps to that channel.

export const ChatSearchPanel = {
  hide: (el, s) => !(s && s.root && s.root.searchOpen),
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  zIndex: 2100,
  flow: 'y',
  align: 'flex-start center',
  paddingTop: 'C',
  background: 'black.5',
  attr: { 'data-search-scrim': 'true' },

  Card: {
    flow: 'y',
    width: 'J',
    maxWidth: '90vw',
    maxHeight: '80vh',
    round: 'Z2',
    theme: 'modal',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    boxShadow: '0 16px 48px var(--color-shadow)',
    overflow: 'hidden',

    Header: {
      flow: 'x',
      align: 'center left',
      gap: 'Z1',
      padding: 'A B',
      borderBottomWidth: '1px',
      borderBottomColor: 'line',
      borderBottomStyle: 'solid',

      Icon: { tag: 'span', text: '🔍', fontSize: 'A', color: 'caption' },
      Input: {
        tag: 'input',
        flex: '1',
        padding: 'V 0',
        border: 'none',
        outline: 'none',
        background: 'transparent',
        color: 'title',
        fontSize: 'A',
        attr: {
          placeholder: 'Search all messages…',
          autofocus: true
        },
        onInput: (e, el) => {
          el.call('searchMessages', e.target.value)
        },
        onKeydown: (e, el, s) => {
          if (e.key === 'Escape') el.call('closeSearch')
        }
      },
      CloseBtn: {
        tag: 'button',
        type: 'button',
        text: 'Esc',
        padding: 'V Z',
        round: 'V',
        border: 'none',
        background: 'overlay',
        color: 'caption',
        cursor: 'pointer',
        fontSize: 'Y2',
        attr: { 'data-action': 'close-search' }
      }
    },

    Body: {
      flex: '1',
      flow: 'y',
      overflow: 'auto',

      Empty: {
        if: (el, s) => {
          const root = s && s.root
          if (!root) return false
          if (!root.searchQuery) return true
          return (root.searchResults || []).length === 0
        },
        flow: 'y',
        align: 'center center',
        padding: 'C',
        color: 'caption',
        fontSize: 'Z2',
        text: (el, s) => {
          if (!s.root.searchQuery) return 'Type to search messages across every channel you belong to.'
          return `No matches for "${s.root.searchQuery}"`
        }
      },

      Results: {
        flow: 'y',
        childExtends: 'ChatSearchResultRow',
        childrenAs: 'state',
        children: (el, s) => (s && s.root && s.root.searchResults) || []
      }
    }
  }
}

export const ChatSearchResultRow = {
  flow: 'y',
  gap: 'V',
  padding: 'A B',
  borderBottomWidth: '1px',
  borderBottomColor: 'line',
  borderBottomStyle: 'solid',
  cursor: 'pointer',
  ':hover': { background: 'overlay' },
  attr: { 'data-search-jump': (el, s) => String((s && s.id) || '') },

  Meta: {
    flow: 'x',
    gap: 'Z',
    align: 'baseline left',

    Channel: {
      tag: 'span',
      fontSize: 'Y2',
      fontWeight: '600',
      color: 'accent',
      text: (el, s) => {
        if (!s) return ''
        if (s.channel_kind === 'channel') return '#' + (s.channel_name || 'channel')
        return 'DM'
      }
    },
    Author: {
      tag: 'span',
      fontSize: 'Y2',
      color: 'caption',
      text: (el, s) => {
        if (!s) return ''
        const root = s.root
        const person = el.call('findPerson', s.author_email)
        return (person && person.name) || s.author_email || ''
      }
    },
    Time: {
      tag: 'span',
      fontSize: 'Y2',
      color: 'caption',
      text: (el, s) => (s && s.created_at) ? el.call('clockTime', s.created_at) : ''
    }
  },

  Body: {
    tag: 'div',
    fontSize: 'Z2',
    color: 'subtitle',
    lineHeight: '1.5',
    text: (el, s) => (s && s.body) || ''
  }
}
